import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43b3cf83"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "value"]

import {computed, withDefaults} from 'vue'

  enum ButtonPriority {
    primary = 'primary',
    secondary = 'secondary'
  }

  export interface Props {
    active?: boolean
    priority?: ButtonPriority
    modelValue: any
    value?: any
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonInput',
  props: {
    active: { type: Boolean, default: true },
    priority: { default: 'primary' },
    modelValue: null,
    value: null
  },
  emits: {
    'update:modelValue': (value) => {
      return !!value
    },

    click: () => {
      return true
    }
  },
  setup(__props: any, { emit }) {

const props = __props as { active: boolean, priority: ButtonPriority, modelValue: any, value?: any };

  

  

  const priorityClass = computed(() => {
    return `is-${props.priority}`
  })

  const classObject = computed(() => {
    return {
      'is-active': props.active,
      [priorityClass.value]: true
    }
  })

  const resource = computed({
    get() {
      return props.modelValue
    },

    set() {
      emit('update:modelValue', props.value || 1)
    }
  })

  const onClick = () => {
    if (props.value) {
      resource.value = props.value
    }

    emit('click')
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    disabled: !props.active,
    class: _normalizeClass(["button-input", _unref(classObject)]),
    value: __props.value,
    onClick: onClick
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})